module.exports = __webpack_public_path__ + "static/media/gallery4.b533e798.png";